import { useTranslation } from 'react-i18next'
import {
  getStoreUrl,
  type AppVersionPayload,
} from '@/shared/hooks/use-app-version-flag'

export function useAppUpdateScreen(payload?: AppVersionPayload) {
  const { t, i18n } = useTranslation()

  const message = i18n.language.startsWith('es')
    ? payload?.['message-es']
    : payload?.['message-en']

  const title = message?.title ?? t('appVersion.title')
  const description = message?.description ?? t('appVersion.description')

  return { title, description, storeUrl: getStoreUrl() }
}
